import { useState, useEffect } from "react";
import { generatePDF } from './PDFGenerator';
import { useParams } from "react-router-dom";
import { db, auth } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import "./ResumePreview.css";

export default function ResumePreview() {
  const { id } = useParams();
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPrinting, setIsPrinting] = useState(false);
  const componentRef = useRef();

  useEffect(() => {
    loadResume();
  }, [id]);

  const loadResume = async () => {
    try {
      const q = query(
        collection(db, "resumes"),
        where("uid", "==", auth.currentUser.uid)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        if (doc.id === id) {
          setResume({ id: doc.id, ...doc.data() });
        }
      });
    } catch (error) {
      console.error("Error loading resume:", error);
    } finally {
      setLoading(false);
    }
  };


// Replace the handlePrint function:
const handlePrint = async () => {
  setIsPrinting(true);
  try {
    await generatePDF(componentRef.current, `${resume.name}_Resume.pdf`);
  } catch (error) {
    console.error('PDF generation failed:', error);
    alert('Failed to generate PDF. Please try again.');
  } finally {
    setIsPrinting(false);
  }
};

// Remove useReactToPrint hook

  if (loading) return <div className="loading">Loading resume...</div>;
  if (!resume) return <div className="not-found">Resume not found</div>;

  const skillsArray = resume.skills ? resume.skills.split(",").map(s => s.trim()) : [];

  return (
    <div className="preview-container">
      <div className="preview-actions">
        <button onClick={() => window.history.back()} className="btn-secondary">
          ← Back
        </button>
        <button 
          onClick={handlePrint} 
          className="btn-primary"
          disabled={isPrinting}
        >
          {isPrinting ? (
            <>
              <span className="spinner"></span>
              Generating PDF...
            </>
          ) : (
            "📥 Download PDF"
          )}
        </button>
      </div>

      <div ref={componentRef} className="resume-preview">
        {/* Header */}
        <div className="resume-header">
          <h1>{resume.name}</h1>
          <h2>{resume.title}</h2>
          <div className="contact-info">
            {resume.email && <span> {resume.email}</span>}
            {resume.phone && <span> {resume.phone}</span>}
            {resume.location && <span> {resume.location}</span>}
          </div>
        </div>

        {/* Summary */}
        {resume.summary && (
          <div className="section">
            <h3>Professional Summary</h3>
            <p>{resume.summary}</p>
          </div>
        )}

        {/* Experience */}
        {resume.experience && (
          <div className="section">
            <h3>Work Experience</h3>
            <div className="content">
              {resume.experience.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          </div>
        )}

        {/* Education */}
        {resume.education && (
          <div className="section">
            <h3>Education</h3>
            <div className="content">
              {resume.education.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          </div>
        )}

        {/* Skills */}
        {skillsArray.length > 0 && (
          <div className="section">
            <h3>Skills</h3>
            <div className="skills-container">
              {skillsArray.map((skill, index) => (
                <span key={index} className="skill-tag">{skill}</span>
              ))}
            </div>
          </div>
        )}

        <div className="resume-footer">
          <p>Generated with Resume Builder</p>
        </div>
      </div>
    </div>
  );
}